export enum BackendCreditTypes {
  AMEX = 'AMEX',
  DISC = 'DISCOVER',
  CREDIT = 'CREDIT',
  MC = 'MASTERCARD',
  VISA = 'VISA'
}
